const aws_appsync_graphqlEndpoint = process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT;
const aws_user_pools_id = process.env.REACT_APP_AWS_USER_POOLS_ID;
const aws_user_pools_web_client_id = process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID;
const oauth_domain = process.env.REACT_APP_OAUTH_DOMAIN;
const aws_user_files_s3_bucket = process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET;
const aws_cognito_identity_pool_id = process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID;

// Get redirect URLs from environment variables
const redirectSignIn = process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000/';
const redirectSignOut = process.env.REACT_APP_REDIRECT_SIGN_OUT || 'http://localhost:3000/';
const redirectSignUp = process.env.REACT_APP_REDIRECT_SIGN_UP || 'http://localhost:3000/';

const redirects = [
  redirectSignIn,
  redirectSignOut,
  redirectSignUp,
  'https://stu-studio.de/',
  'https://www.stu-studio.de/'
];

const awsmobile = {
  aws_project_region: process.env.REACT_APP_AWS_REGION,
  aws_appsync_graphqlEndpoint,
  aws_appsync_region: process.env.REACT_APP_AWS_REGION,
  aws_appsync_authenticationType: process.env.REACT_APP_AWS_APPSYNC_AUTH_TYPE || 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: process.env.REACT_APP_AWS_APPSYNC_API_KEY,
  aws_user_pools_id,
  aws_user_pools_web_client_id,
  aws_cognito_identity_pool_id,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION || process.env.REACT_APP_AWS_REGION,
  oauth: {
    domain: oauth_domain,
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: redirects,   // array as required by Amplify v6
    redirectSignOut: redirects,  // array as required by Amplify v6
    responseType: 'code'
  },
  aws_user_files_s3_bucket,
  aws_user_files_s3_bucket_region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION || 'eu-central-1'
};

export default awsmobile;